function WorkoutImage({ className = '', onClick, thumbnailUrl }) {
    const defaultImage = 'https://cdn.shopify.com/s/files/1/0667/9599/5332/files/default-workout-image.png?v=1767240337';
    
    const handleClick = (e) => {
        if (onClick) {
            e.preventDefault();
            e.stopPropagation();
            onClick(e);
        }
    };
    
    return (
        <div 
            className={`tw-relative ${onClick ? 'tw-cursor-pointer' : ''}`}
            onClick={handleClick}
            onTouchEnd={handleClick}
            role={onClick ? 'button' : undefined}
            tabIndex={onClick ? 0 : undefined}
            style={{ 
                display: 'inline-block', 
                width: '100%',
                touchAction: onClick ? 'manipulation' : 'auto'
            }}
        >
            <img
                src={thumbnailUrl || defaultImage}
                alt="Workout"
                className={className}
                style={{ pointerEvents: 'none', userSelect: 'none' }}
            />
        </div>
    );
}

export default WorkoutImage;
